import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface KeepSessionOpenDialogInjectedData {
  checkOutTime: number;
  timeOut: number;
}

@Component({
  selector: 'app-keep-session-open-dialog',
  templateUrl: './keep-session-open-dialog.component.html',
  styleUrls: ['./keep-session-open-dialog.component.scss'],
})
export class KeepSessionOpenDialogComponent implements OnDestroy {
  public timerCount = 0;
  private timeUnit: 'hours' | 'minutes' | 'seconds' = 'seconds';

  constructor(
    public dialog: MatDialogRef<KeepSessionOpenDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: KeepSessionOpenDialogInjectedData
  ) {
    this.timerCount = this.data.timeOut;
    setTimeout(this.timeOutHandler, this.nextTimeOut);
  }

  ngOnDestroy(): void {
    this.timerCount = 0;
  }

  private get nextTimeOut(): number {
    const multiplier = this.timeUnit === 'hours' ? 60 * 60 : this.timeUnit === 'minutes' ? 60 : 1;
    return this.data.checkOutTime * multiplier * 1000;
  }

  public get spinnerValue(): number {
    return (this.timerCount / this.data.timeOut) * 100;
  }

  private timeOutHandler = () => {
    this.timerCount--;
    if (this.timerCount > 0) {
      setTimeout(this.timeOutHandler, this.nextTimeOut);
    }
  };

  deny(): void {
    this.dialog.close(false);
  }

  confirm(): void {
    this.dialog.close(true);
  }
}
